export default "__VITE_ASSET__DpXZ0AjL__"